module.exports = __webpack_public_path__ + "static/media/4.030267c7.jpg";